import { memo } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import Button from "@material-ui/core/Button";
import { isMobile } from "react-device-detect";
import { LEGACY_PAGE } from "src/router/routes";
import MyProfileStatus from "src/components/common/OnBoarding/MyProfileStatus";
import MyProfileNav from "src/components/common/OnBoarding/MyProfileNav";

interface RootState {
  onBoarding: {
    completedSteps: any;
  };
  auth: {
    firstName: string;
    useProfileIframe: boolean;
  };
}

interface DashboardBannerV2Props {
  bgImgClass: string;
}

const DashboardBannerV2 = ({ bgImgClass }: DashboardBannerV2Props) => {
  const { t } = useTranslation();
  const history = useHistory();
  const completedSteps = useSelector((state: RootState) => state.onBoarding.completedSteps);
  const username = useSelector((state: RootState) => state.auth.firstName);
  const useProfileIframe = useSelector((state: RootState) => state.auth.useProfileIframe);



  const redirectToProfile = () => {
    const location = {
      pathname: LEGACY_PAGE,
      search: "?page=basic-info",
    };
    history.push(location);
  };

  

  return (
    <Container
      id="dashboard-banner"
      fluid
      className={
        isMobile
          ? `dashboardBannerV2AddRefer dashProfileMain ${bgImgClass}`
          : `dashboardBannerV2 dashProfileMain ${bgImgClass}`
      }
    >
      {useProfileIframe && (
        <Container>
          <Row>
            <Col sm={12} xs={12} md={12} lg={12}>
              <p className="myProfileTextMobComplete dashBMargTop">
                <span className="myProfileNote myProfBannerTextComp">
                  {" "}
                  <span className="dashBannerTxtHead">
                    {t("dashboard.banner.dashProfileBannerTxt1")}
                    <span>{username ?? ""}</span>
                    !&nbsp;
                    <span className="complSubHeadMob">
                      {t("dashboard.banner.dashProfileBannerTxt2")}
                    </span>
                  </span>
                </span>
                <span className="dashBannerSubHead dashBannerSubHeadMob">
                  {t("dashboard.banner.dashProfileBannerTxt3")}
                </span>
                <br />
                <div className="text-centerMob">
                  <span className="">
                    <Button
                      className="letsGoBtnDashB"
                      id="profileButton"
                      onClick={redirectToProfile}
                    >
                      {t("dashboard.banner.buttonLabel")}
                    </Button>
                  </span>
                </div>
              </p>
            </Col>
          </Row>
        </Container>
      )}
      {(!useProfileIframe && Object.keys(completedSteps).length < 4) ||
      Object.keys(completedSteps).length < 5 ? (
        <Container>
          <Row>
            <Col sm={12} xs={12} md={1} lg={1} className="myProfileStatus">
              <div className="dashProfileStatus">
                {" "}
                <MyProfileStatus />
              </div>
            </Col>
            <Col sm={10} xs={12} md={11} lg={11}>
              <div className="dashProfileNav">
                <MyProfileNav />
              </div>
            </Col>
          </Row>
        </Container>
      ) : (
        <Container>
          <Row>
            <Col sm={12} xs={12} md={12} lg={12}>
              <p className="myProfileTextMobComplete">
                <span className="dashBannerTxtHead">
                  {t("dashboard.banner.dashProfileBannerTxt1")}
                  <span>{username ? ` ${username}` : ""}</span>
                  !&nbsp;
                  <span className="complSubHeadMob">
                    {t("dashboard.banner.myProfileNavCompleteTxt2")}{" "}
                  </span>
                </span>
                <span className="dashBannerSubHead dashBannerSubHeadMob">
                  {t("dashboard.banner.dashProfileBannerTxt4")} &quot;
                  {t("dashboard.banner.dashProfileBannerTxt5")}&quot;{" "}
                  {t("dashboard.banner.dashProfileBannerTxt6")}
                </span>
                <br />
              </p>
            </Col>
          </Row>
        </Container>
      )}
    </Container>
  );
};

export default memo(DashboardBannerV2);
